'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseButtons = require('@bibliocommons/base-buttons');

require('../styles/DeletingOverlay.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  message: _react2.default.PropTypes.string,
  handleCancel: _react2.default.PropTypes.func.isRequired
};

var DeletingOverlay = function DeletingOverlay(_ref) {
  var message = _ref.message,
      handleCancel = _ref.handleCancel;
  return _react2.default.createElement(
    'div',
    { className: 'cp-user-list-deleting-overlay' },
    _react2.default.createElement(
      'div',
      { className: 'contents' },
      _react2.default.createElement(
        'span',
        { className: 'message', 'data-test-id': 'deleting-item-message' },
        message
      ),
      _react2.default.createElement(
        _baseButtons.TextButton,
        { className: 'undo-button', handleClick: handleCancel },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'undo' })
      )
    )
  );
};

DeletingOverlay.propTypes = propTypes;

exports.default = DeletingOverlay;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/deleting-overlay/components/DeletingOverlay.component.js
// module id = 1286
// module chunks = 0